import { useState, useEffect } from "react";
import { Link } from "react-scroll";

const navLinks = [
  { label: "Home", to: "hero" },
  { label: "About", to: "about-us" },
  { label: "Experience", to: "experience" },
  { label: "Services", to: "service" },
  { label: "Projects", to: "projects" },
  { label: "Contact", to: "contact" },
];

const Header = () => {
  const [fixed, setFixed] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setFixed(window.scrollY >= 80);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`header${fixed ? " navbar_fixed" : ""}`}>
      <div className="container">
        <nav className="header__nav">
          <a href="/" className="header__brand" aria-label="Abdul Aziz Portfolio">
            TAMIM<span className="header__brand-accent">.</span>
          </a>

          <ul className={`header__menu${menuOpen ? " header__menu--open" : ""}`}>
            {navLinks.map((link) => (
              <li key={link.to} className="header__menu-item">
                <Link
                  activeClass="active"
                  className="header__nav-link"
                  to={link.to}
                  spy={true}
                  smooth={true}
                  duration={600}
                  offset={-70}
                  onClick={closeMenu}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>

          <Link
            to="contact"
            smooth={true}
            duration={600}
            offset={-70}
            className="header__cta"
          >
            Hire Me
          </Link>

          <button
            className={`header__toggle${menuOpen ? " header__toggle--open" : ""}`}
            onClick={() => setMenuOpen((o) => !o)}
            aria-label="Toggle navigation"
            aria-expanded={menuOpen}
          >
            <span className="header__toggle-bar" />
            <span className="header__toggle-bar" />
            <span className="header__toggle-bar" />
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
